import React from 'react';
import { Outlet } from 'react-router-dom';
import TopBar from './TopBar';
import BottomNav from './BottomNav';
import InstallPrompt from './InstallPrompt';
import FloatingRecordButton from './FloatingRecordButton';
import RecordingControls from './RecordingControls';
import PrivacyNotice from './PrivacyNotice';
import RecordingPreview from './RecordingPreview';
import { useInstallReward } from '../../lib/useInstallReward';

export default function AppShell() {
  useInstallReward();
  return (
    <div className="min-h-screen relative">
      {/* Ambient orbs */}
      <div className="orb bg-violet-600/40 w-96 h-96 top-0 -left-20" />
      <div className="orb bg-cyan-500/30 w-96 h-96 top-40 right-0" />
      <div className="orb bg-fuchsia-600/20 w-80 h-80 bottom-0 left-1/2" />

      <TopBar />
      <main className="relative pb-24 md:pb-8 max-w-7xl mx-auto px-4 sm:px-6 py-6 min-h-[70vh]">
        <Outlet />
      </main>
      <BottomNav />
      <InstallPrompt />

      {/* Global recorder UI */}
      <RecordingControls />
      <FloatingRecordButton />
      <PrivacyNotice />
      <RecordingPreview />
    </div>
  );
}
